module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Medium.70f6288.woff2";